
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.repair-product[data-product-id]');
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';
    document.body.classList.add('repair-page-dark');

    const copy = JSON.parse(section.querySelector('[data-repair-product-copy]').textContent);
    const productTitle = copy.title;
    const optionButtons = Array.from(section.querySelectorAll('[data-repair-option]'));
    const extraServiceButtons = Array.from(section.querySelectorAll('[data-extra-service]'));
    const totalSale = section.querySelector('[data-total-sale]');
    const totalRegular = section.querySelector('[data-total-regular]');
    const selectedCount = section.querySelector('[data-selected-count]');
    const extraPriceNote = section.querySelector('[data-extra-price-note]');
    const mobileTotal = section.querySelector('[data-mobile-total]');
    const mobileSelected = section.querySelector('[data-mobile-selected]');
    const mobileSummary = section.querySelector('[data-mobile-summary]');
    const appointmentForm = section.querySelector('#appointment-form');
    const quoteForm = section.querySelector('#quote-form');
    const callbackForm = section.querySelector('#callback-form');
    const appointmentSummary = section.querySelector('[data-appointment-summary]');
    const appointmentSummaryText = section.querySelector('[data-appointment-summary-text]');
    const progressStep1 = section.querySelector('[data-progress-step="1"]');
    const progressStep2 = section.querySelector('[data-progress-step="2"]');
    const progressStep3 = section.querySelector('[data-progress-step="3"]');
    const servicesSection = section.querySelector('[data-services-section]');
    const servicesGrid = section.querySelector('[data-services-grid]');
    const servicesToggle = section.querySelector('[data-toggle-services]');
    const servicesToggleLabel = section.querySelector('[data-services-toggle-label]');
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const scrollBehavior = () => reducedMotion.matches ? 'auto' : 'smooth';
    const formTriggers = [
      { selector: '[data-open-appointment]', panel: appointmentForm },
      { selector: '[data-open-callback]', panel: callbackForm },
      { selector: '[data-open-quote]', panel: quoteForm }
    ];

    function syncFormAccessibility() {
      formTriggers.forEach(({ selector, panel }) => {
        if (!panel) return;
        panel.setAttribute('tabindex', '-1');
        panel.setAttribute('role', 'region');
        const heading = panel.querySelector('h2, h3, .repair-callback__heading strong');
        const trigger = section.querySelector(selector);
        const label = heading?.textContent.trim() || trigger?.textContent.trim();
        if (label) panel.setAttribute('aria-label', label);
        section.querySelectorAll(selector).forEach(button => {
          button.setAttribute('aria-controls', panel.id);
          button.setAttribute('aria-expanded', String(!panel.hidden));
        });
      });
    }

    function focusRepairPanel(panel) {
      if (!panel || panel.hidden) return;
      syncFormAccessibility();
      panel.focus({ preventScroll: true });
    }

    syncFormAccessibility();

    let currentPreset = '';
    let lastExpectedValue = '';

    const moneyFormatter = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: copy.currency
    });

    function selectedOptions() {return optionButtons.filter((button) => button.classList.contains('is-selected'));}
    function selectedExtraServices() {return extraServiceButtons.filter((button) => button.classList.contains('is-selected'));}

    function setProgressState(step, active, complete) {
      if (!step) return;

      step.classList.toggle('is-active', Boolean(active));
      step.classList.toggle('is-complete', Boolean(complete));

      if (active) {
        step.setAttribute('aria-current', 'step');
      } else {
        step.removeAttribute('aria-current');
      }
    }

    function updateProgressSteps(options = {}) {
      const repairCount = selectedOptions().length;
      const extraCount = selectedExtraServices().length;
      const appointmentOpen =
        options.appointmentOpen === true ||
        Boolean(appointmentForm && appointmentForm.hidden === false);

      setProgressState(
        progressStep1,
        !appointmentOpen,
        repairCount > 0
      );

      setProgressState(
        progressStep2,
        repairCount > 0 && !appointmentOpen,
        extraCount > 0 || appointmentOpen
      );

      setProgressState(
        progressStep3,
        appointmentOpen || repairCount > 0,
        appointmentOpen
      );
    }

    function setServicesOpen(open) {
      if (!servicesGrid || !servicesToggle) return;

      const shouldOpen = Boolean(open);
      servicesGrid.hidden = !shouldOpen;
      servicesToggle.setAttribute('aria-expanded', String(shouldOpen));

      if (servicesToggleLabel) {
        servicesToggleLabel.textContent = shouldOpen
          ? 'Masquer les services optionnels'
          : 'Voir les services optionnels';
      }
    }

    function updateServicesAvailability() {
      if (!servicesSection) return;

      const repairSelected = selectedOptions().length > 0;
      servicesSection.classList.toggle('is-locked', !repairSelected);

      if (servicesToggle) {
        servicesToggle.disabled = !repairSelected;
      }

      if (!repairSelected) {
        extraServiceButtons.forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });

        setServicesOpen(false);
      }
    }

    if (servicesToggle) {
      servicesToggle.addEventListener('click', function () {
        if (servicesToggle.disabled || !servicesGrid) return;
        setServicesOpen(servicesGrid.hidden);
      });
    }

    mobileMedia.addEventListener?.('change', function () {
      updateServicesAvailability();

      scheduleFloatingWidgetScan();
    });

    function hideExternalFloatingWidgets() {
      if (!mobileMedia.matches) return;

      const candidates = Array.from(
        document.querySelectorAll(
          'body a[href^="tel:"], body a[href*="wa.me"], body a[href*="whatsapp"]'
        )
      );

      candidates.forEach((candidate) => {
        if (section.contains(candidate)) return;

        let element = candidate;
        let node = candidate;
        for (let depth = 0; depth < 5 && node && node !== document.body; depth += 1) {
          const style = window.getComputedStyle(node);
          if (style.position === 'fixed' || style.position === 'sticky') {
            element = node;
            break;
          }
          node = node.parentElement;
        }

        if (!element || section.contains(element)) return;

        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        const fixed = style.position === 'fixed' || style.position === 'sticky';
        const floatingSize = rect.width >= 40 && rect.height >= 40;
        const bottomArea = rect.bottom > window.innerHeight - 260;

        if (fixed && floatingSize && bottomArea) {
          element.classList.add('repair-external-widget-managed');
        }
      });
    }

    function scheduleFloatingWidgetScan() {
      hideExternalFloatingWidgets();
      window.setTimeout(hideExternalFloatingWidgets, 300);
      window.setTimeout(hideExternalFloatingWidgets, 1200);
      window.setTimeout(hideExternalFloatingWidgets, 3000);
    }

    const floatingObserver = new MutationObserver(function () {
      if (!mobileMedia.matches) return;
      window.clearTimeout(window.__pcbFloatingScanTimer);
      window.__pcbFloatingScanTimer = window.setTimeout(hideExternalFloatingWidgets, 80);
    });
    floatingObserver.observe(document.body, { childList: true, subtree: true });
    scheduleFloatingWidgetScan();

    function updateSummary() {
      const selected = selectedOptions();
      const extras = selectedExtraServices();
      const hasQuote = selected.some(
        (button) => button.dataset.quote === 'true' || Number(button.dataset.salePrice || 0) === 0
      );

      const saleCents = selected.reduce(
        (sum, button) => sum + Math.max(0, Number(button.dataset.salePrice || 0)),
        0
      );

      const regularCents = selected.reduce(
        (sum, button) => {
          if (button.dataset.quote === 'true' || Number(button.dataset.salePrice || 0) === 0) return sum;
          return sum + Math.max(0, Number(button.dataset.regularPrice || 0));
        },
        0
      );

      let totalLabel = '—';
      if (selected.length > 0) {
        if (hasQuote && saleCents > 0) {
          totalLabel = `${moneyFormatter.format(saleCents / 100)} + devis`;
        } else if (hasQuote) {
          totalLabel = 'Sur devis';
        } else {
          totalLabel = moneyFormatter.format(saleCents / 100);
        }
      }

      const hasExtras = extras.length > 0;
      const visibleTotalLabel = hasExtras && totalLabel !== '—'
        ? `${totalLabel} + service`
        : totalLabel;

      totalSale.textContent = visibleTotalLabel;
      const repairList = section.querySelector('[data-selected-repair-list]');
      if (repairList) {
        repairList.replaceChildren(...selected.concat(extras).map(button => {
          const item = document.createElement('li');
          item.textContent = button.dataset.service;
          return item;
        }));
        repairList.hidden = selected.length + extras.length === 0;
      }
      section.querySelectorAll('[data-quick-total]').forEach(node => { node.textContent = visibleTotalLabel; });
      const contactLink = section.querySelector('.repair-button--whatsapp');
      if (contactLink && window.PCBRepair) {
        contactLink.href = window.PCBRepair.whatsapp([productTitle, getDefectDescription(), visibleTotalLabel !== '—' ? visibleTotalLabel : ''].filter(Boolean).join(' — '));
      }

      const repairLabel = selected.length ? `${selected.length} réparation${selected.length > 1 ? 's' : ''}` : '';
      const extraLabel = extras.length ? `${extras.length} service${extras.length > 1 ? 's' : ''} optionnel${extras.length > 1 ? 's' : ''}` : '';
      const fullLabel = [repairLabel, extraLabel].filter(Boolean).join(' + ');
      selectedCount.textContent = fullLabel
        ? `${fullLabel} ${extras.length ? 'sélectionné' : 'sélectionnée'}${selected.length + extras.length > 1 ? 's' : ''}`
        : 'Aucune réparation sélectionnée';

      if (extraPriceNote) {
        extraPriceNote.hidden = !hasExtras;
        extraPriceNote.textContent = extras.length > 1
          ? 'Services optionnels : tarifs confirmés en boutique.'
          : 'Service optionnel : tarif confirmé en boutique.';
      }

      if (mobileTotal) {
        mobileTotal.textContent = hasExtras && totalLabel !== '—'
          ? `${totalLabel} + service`
          : totalLabel;
      }

      if (mobileSelected) {
        mobileSelected.textContent = fullLabel || 'Sélectionnez une panne';
      }

      const formOpen = document.body.classList.contains('repair-form-open');
      const showMobileSummary = !formOpen && (selected.length + extras.length > 0);

      if (mobileSummary) {
        mobileSummary.classList.toggle('is-visible', showMobileSummary);
      }

      document.body.classList.toggle(
        'repair-mobile-summary-visible',
        showMobileSummary
      );

      if (!hasQuote && regularCents > saleCents) {
        totalRegular.hidden = false;
        totalRegular.textContent = moneyFormatter.format(regularCents / 100);
      } else {
        totalRegular.hidden = true;
        totalRegular.textContent = '';
      }
    }

    function getDefectDescription() {
      const selectedRepairs=selectedOptions().map((button)=>{
        const service = button.dataset.service;
        if (!service) return '';
        return button.dataset.quote === 'true' || Number(button.dataset.salePrice || 0) === 0
          ? `${service} (sur devis)`
          : service;
      }).filter(Boolean);
      const selectedExtras=selectedExtraServices().map((button)=>button.dataset.service).filter(Boolean);
      const details=[];
      if(selectedRepairs.length) details.push(`Réparations : ${selectedRepairs.join(' + ')}`);
      if(selectedExtras.length) details.push(`Services : ${selectedExtras.join(' + ')}`);
      if(currentPreset) details.push(currentPreset);
      return details.length?details.join(' | '):'Panne non précisée';
    }

    function buildFullAppointmentValue() {
      return `${productTitle} — ${getDefectDescription()}`;
    }

    function findModelInput() {
      if (!appointmentForm) return null;

      const directSelectors = [
        'input[name="text-5"], textarea[name="text-5"]',
        'input[data-label="Modèle"]',
        'input[data-label="Modele"]',
        'input[data-label="Service"]'
      ];

      for (const selector of directSelectors) {
        const input = appointmentForm.querySelector(selector);
        if (input) return input;
      }

      const labels = Array.from(
        appointmentForm.querySelectorAll(
          'label, .globo-label, .label-content, [data-label]'
        )
      );

      const matchingLabel = labels.find((label) => {
        const text = (
          label.getAttribute('data-label') ||
          label.textContent ||
          ''
        )
          .trim()
          .toLowerCase();

        return (
          text.includes('modèle') ||
          text.includes('modele') ||
          text.includes('service')
        );
      });

      if (!matchingLabel) return null;

      const forId =
        matchingLabel.getAttribute('for') ||
        matchingLabel.closest('label')?.getAttribute('for');

      if (forId) {
        const escapedId = window.CSS && CSS.escape
          ? CSS.escape(forId)
          : forId.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|/@])/g, '\$1');

        const byId = appointmentForm.querySelector(`#${escapedId}`);
        if (byId) return byId;
      }

      const control =
        matchingLabel.closest('.globo-form-control') ||
        matchingLabel.parentElement;

      return control
        ? control.querySelector('input, textarea, select')
        : null;
    }

    function renameModelLabel() {
      if (!appointmentForm) return;

      const labels = Array.from(
        appointmentForm.querySelectorAll(
          'label, .globo-label, .label-content, [data-label]'
        )
      );

      labels.forEach((label) => {
        const text = (
          label.getAttribute('data-label') ||
          label.textContent ||
          ''
        )
          .trim()
          .toLowerCase();

        if (
          text === 'modèle' ||
          text === 'modele' ||
          text === 'service'
        ) {
          if (label.classList.contains('label-content')) {
            label.textContent = 'Modèle et réparation';
            label.setAttribute('data-label', 'Modèle et réparation');
          }
        }
      });
    }

    function setNativeInputValue(input, value) {
      if (!input) return;

      const prototype =
        input.tagName === 'TEXTAREA'
          ? HTMLTextAreaElement.prototype
          : HTMLInputElement.prototype;

      const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');

      if (descriptor && descriptor.set) {
        descriptor.set.call(input, value);
      } else {
        input.value = value;
      }

      input.setAttribute('value', value);
    }

    function enforceFullAppointmentValue() {
      const input = findModelInput();
      if (!input) return false;

      renameModelLabel();

      const expectedValue = buildFullAppointmentValue();
      lastExpectedValue = expectedValue;

      if (input.value !== expectedValue) {
        setNativeInputValue(input, expectedValue);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Globo peut réinitialiser le champ pendant son chargement. Ne jamais
      // bloquer la saisie si l'application n'a pas conservé le préremplissage.
      const filled = input.value === expectedValue;
      input.readOnly = filled;
      input.title = filled ? expectedValue : '';
      return filled;
    }

    function startAppointmentFieldGuard() {
      let attempts = 0;
      enforceFullAppointmentValue();

      const interval = window.setInterval(function () {
        attempts += 1;
        enforceFullAppointmentValue();

        if (attempts >= 40 || appointmentForm.hidden) {
          window.clearInterval(interval);
        }
      }, 250);

      window.setTimeout(enforceFullAppointmentValue, 50);
      window.setTimeout(enforceFullAppointmentValue, 500);
      window.setTimeout(enforceFullAppointmentValue, 1200);
      window.setTimeout(enforceFullAppointmentValue, 2500);
      window.setTimeout(enforceFullAppointmentValue, 5000);
    }

    optionButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const isSelected = button.classList.toggle('is-selected');
        button.setAttribute('aria-pressed', String(isSelected));

        currentPreset = '';
        updateServicesAvailability();
        updateSummary();
        updateProgressSteps();

        if (
          mobileMedia.matches &&
          selectedOptions().length > 0 &&
          servicesSection
        ) {
          servicesSection.classList.remove('is-locked');
        }

        if (appointmentForm && !appointmentForm.hidden) {
          enforceFullAppointmentValue();
        }
      });
    });

    extraServiceButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const isSelected = button.classList.toggle('is-selected');
        button.setAttribute('aria-pressed', String(isSelected));

        updateSummary();
        updateProgressSteps();

        if (appointmentForm && !appointmentForm.hidden) {
          enforceFullAppointmentValue();
        }
      });
    });

    section.querySelectorAll('[data-toggle-target]').forEach((button) => {
      button.addEventListener('click', function () {
        const targetPanel = section.querySelector(button.dataset.toggleTarget);
        if (!targetPanel) return;

        targetPanel.hidden = !targetPanel.hidden;
        button.setAttribute('aria-expanded', String(!targetPanel.hidden));
      });
    });

    function closeFormPanels(except) {
      [callbackForm, appointmentForm, quoteForm].forEach((form) => {
        if (form && form !== except) form.hidden = true;
      });
      if (appointmentSummary && except !== appointmentForm) appointmentSummary.hidden = true;
    }

    function setFormOpenState(open) {
      syncFormAccessibility();
      document.body.classList.toggle('repair-form-open', Boolean(open));
      if (open && mobileSummary) {
        mobileSummary.classList.remove('is-visible');
        document.body.classList.remove('repair-mobile-summary-visible');
      }
      scheduleFloatingWidgetScan();
      updateSummary();
    }

    function updateAppointmentSummary() {
      if (!appointmentSummary || !appointmentSummaryText) return;
      appointmentSummary.hidden = false;
      const summary = getDefectDescription();
      if (appointmentSummaryText.textContent !== summary) appointmentSummaryText.textContent = summary;
    }

    const bookingCopy = {
      contact_heading: copy.contact_heading,
      slot_heading: copy.slot_heading,
      date_label: copy.date_label,
      time_label: copy.time_label,
      date_placeholder: copy.date_placeholder,
      name_placeholder: copy.name_placeholder,
      first_name_placeholder: copy.first_name_placeholder,
      phone_placeholder: copy.phone_placeholder,
      email_placeholder: copy.email_placeholder,
      submit: copy.submit,
      submitting: copy.submitting,
      past_date: copy.past_date,
      empty_date: copy.empty_date,
      past_time: copy.past_time,
      empty_time: copy.empty_time,
      slot_hint: copy.slot_hint,
      outside_hours: 'Choisissez une heure entre 10:00 et 18:30.',
      success_title: copy.success_title,
      success_text: copy.success_text
    };

    function bookingToday() {
      const parts = new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'}).formatToParts(new Date());
      const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
      return {date: `${values.year}-${values.month}-${values.day}`, time: `${values.hour}:${values.minute}`};
    }

    function clearBookingError() {
      const error = appointmentForm.querySelector('[data-booking-error]');
      if (error) { error.hidden = true; error.textContent = ''; }
      appointmentForm.querySelectorAll('[aria-invalid="true"]').forEach(input => input.removeAttribute('aria-invalid'));
    }

    function enhanceBookingLayout() {
      if (!appointmentForm) return;
      const get = name => appointmentForm.querySelector(`input[name="${name}"]`);
      const fields = [
        [get('text'), 'family-name', bookingCopy.name_placeholder, 'text'],
        [get('text-3'), 'given-name', bookingCopy.first_name_placeholder, 'text'],
        [get('email'), 'email', bookingCopy.email_placeholder, 'email'],
        [get('phone'), 'tel', bookingCopy.phone_placeholder, 'tel']
      ];
      fields.forEach(([input, autocomplete, placeholder, type]) => {
        if (!input) return;
        input.autocomplete = autocomplete;
        input.placeholder = placeholder;
        input.type = type;
        input.required = true;
        if (type === 'email' || type === 'tel') {
          input.inputMode = type;
          input.autocapitalize = 'off';
        }
      });
      const date = get('datetime');
      const time = get('text-4');
      const dateControl = date?.closest('.globo-form-control');
      const timeControl = time?.closest('.globo-form-control');
      const firstControl = get('text')?.closest('.globo-form-control');
      const panel = firstControl?.parentElement;
      if (panel && dateControl?.parentElement === panel && timeControl?.parentElement === panel) {
        panel.classList.add('repair-booking__grid');
        if (!panel.querySelector('[data-booking-contact-heading]')) {
          const heading = document.createElement('h3');
          heading.className = 'repair-booking__group';
          heading.dataset.bookingContactHeading = '';
          heading.textContent = bookingCopy.contact_heading;
          panel.insertBefore(heading, firstControl);
        }
        if (dateControl.nextElementSibling !== timeControl) panel.insertBefore(dateControl, timeControl);
        if (!panel.querySelector('[data-booking-slot-heading]')) {
          const heading = document.createElement('h3');
          heading.className = 'repair-booking__group repair-booking__group--slot';
          heading.dataset.bookingSlotHeading = '';
          heading.textContent = bookingCopy.slot_heading;
          panel.insertBefore(heading, dateControl);
        }
        if (!panel.querySelector('[data-booking-slot-hint]')) {
          const hint = document.createElement('p');
          hint.className = 'repair-booking__hint';
          hint.dataset.bookingSlotHint = '';
          hint.textContent = '10:00 – 18:30 · ' + bookingCopy.slot_hint;
          timeControl.after(hint);
        }
      }
      [[dateControl, bookingCopy.date_label], [timeControl, bookingCopy.time_label]].forEach(([control, text]) => {
        const label = control?.querySelector('.label-content');
        if (label && label.textContent !== text) label.textContent = text;
      });
      if (date) {
        const today = bookingToday().date;
        date.required = true;
        date.placeholder = bookingCopy.date_placeholder;
        date.min = today;
        if (date._flatpickr && date.dataset.pcbMinDate !== today) {
          date.dataset.pcbMinDate = today;
          date._flatpickr.set('minDate', today);
        }
      }
      const model = findModelInput();
      if (model?.readOnly) {
        const control = model.closest('.globo-form-control');
        if (control) control.hidden = true;
      }
      const submit = appointmentForm.querySelector('button[type="submit"]');
      if (submit && !submit.dataset.pcbBookingButton) {
        submit.dataset.pcbBookingButton = 'true';
        const spinner = submit.querySelector('.spinner');
        submit.replaceChildren();
        if (spinner) submit.appendChild(spinner);
        submit.appendChild(document.createTextNode(bookingCopy.submit));
        submit.dataset.submitText = submit.innerHTML;
        submit.dataset.submittingText = bookingCopy.submitting;
      }
      appointmentForm.querySelectorAll('.message.success').forEach(message => {
        const title = message.querySelector('.gfb__content-title');
        const content = message.querySelector('.content');
        if (title && title.textContent !== bookingCopy.success_title) title.textContent = bookingCopy.success_title;
        if (content && content.textContent !== bookingCopy.success_text) content.textContent = bookingCopy.success_text;
      });
    }

    function validateBookingSlot() {
      const date = appointmentForm.querySelector('input[name="datetime"]');
      const time = appointmentForm.querySelector('input[name="text-4"]');
      if (!date || !time) return true;
      const now = bookingToday();
      let message = '';
      let field = date;
      const validDate = /^\d{4}-\d{2}-\d{2}$/.test(date.value) && !Number.isNaN(Date.parse(date.value)) && new Date(date.value).toISOString().slice(0, 10) === date.value;
      if (!date.value) message = bookingCopy.empty_date;
      else if (!validDate || date.value < now.date) message = bookingCopy.past_date;
      else if (!time.value) { message = bookingCopy.empty_time; field = time; }
      else if (!/^\d{2}:\d{2}$/.test(time.value) || time.value < '10:00' || time.value > '18:30') { message = bookingCopy.outside_hours; field = time; }
      else if (date.value === now.date && time.value <= now.time) { message = bookingCopy.past_time; field = time; }
      if (!message) return true;
      const error = appointmentForm.querySelector('[data-booking-error]');
      if (error) { error.textContent = message; error.hidden = false; }
      field.setAttribute('aria-invalid', 'true');
      field.focus({preventScroll: true});
      field.scrollIntoView({block: 'center', behavior: scrollBehavior()});
      if (field === date && date._flatpickr) date._flatpickr.open();
      return false;
    }

    function enhanceAppointmentFields() {
      enforceFullAppointmentValue();
      enhanceBookingLayout();
      const time = appointmentForm?.querySelector('input[id="102025-text-4"][name="text-4"]');
      if (!time || time._flatpickr || time.readOnly) return;
      if ((time.getAttribute('oninput') || '').includes('handleInputOnlyNumbers')) {
        time.removeAttribute('oninput');
        time.oninput = null;
      }
      if (time.dataset.pcbTimeReady) return;
      if (time.type !== 'text' && time.type !== 'time') return;
      const value = time.value.trim();
      const parts = value.match(/^(\d{1,2})(?:[:h](\d{2}))?$/i);
      const normalized = parts && Number(parts[1]) < 24 && Number(parts[2] || 0) < 60
        ? parts[1].padStart(2, '0') + ':' + (parts[2] || '00') : '';
      time.dataset.pcbTimeReady = 'true';
      time.type = 'time';
      time.step = '60';
      time.min = '10:00';
      time.max = '18:30';
      time.required = true;
      time.value = normalized;
      time.style.colorScheme = 'dark';
      if (normalized !== value) {
        time.dispatchEvent(new Event('input', { bubbles: true }));
        time.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    section.querySelectorAll('[data-close-repair-form]').forEach(button => {
      button.addEventListener('click', () => {
        closeFormPanels(null);
        setFormOpenState(false);
        updateProgressSteps();
        section.querySelector('#repair-options')?.focus({preventScroll: true});
        section.querySelector('#repair-options')?.scrollIntoView({behavior: scrollBehavior(), block: 'start'});
      });
    });

    section.querySelectorAll('[data-open-callback]').forEach((button) => {
      button.addEventListener('click', function () {
        if (!callbackForm) return;
        closeFormPanels(callbackForm);
        callbackForm.hidden = false;
        var repairField = callbackForm.querySelector('[data-callback-repairs]');
        if (repairField) repairField.value = getDefectDescription();
        setFormOpenState(true);
        focusRepairPanel(callbackForm);
        callbackForm.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
      });
    });

    section.querySelectorAll('[data-open-appointment]').forEach((button) => {
      button.addEventListener('click', function () {
        if (!appointmentForm) return;

        currentPreset = button.dataset.servicePreset || '';
        closeFormPanels(appointmentForm);
        appointmentForm.hidden = false;
        updateAppointmentSummary();
        updateProgressSteps({ appointmentOpen: true });
        setFormOpenState(true);

        startAppointmentFieldGuard();
        window.setTimeout(enhanceAppointmentFields, 120);
        window.setTimeout(enhanceAppointmentFields, 700);
        window.setTimeout(enhanceAppointmentFields, 1800);

        focusRepairPanel(appointmentForm);
        appointmentForm.scrollIntoView({
          behavior: scrollBehavior(),
          block: 'start'
        });
      });
    });

    section.querySelectorAll('[data-open-quote]').forEach((button) => {
      button.addEventListener('click', function () {
        if (!quoteForm) return;
        closeFormPanels(quoteForm);
        quoteForm.hidden = false;
        setFormOpenState(true);

        focusRepairPanel(quoteForm);
        quoteForm.scrollIntoView({
          behavior: scrollBehavior(),
          block: 'start'
        });
      });
    });

    if (appointmentForm) {
      const validateAppointmentTime = function (event) {
        if (event.type === 'click' && !event.target.closest('button[type="submit"], input[type="submit"], button.submit, .action.submit')) return;
        enhanceAppointmentFields();
        const form = appointmentForm.querySelector('form');
        if (!validateBookingSlot() || (form && !form.checkValidity())) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (form && !form.checkValidity()) form.reportValidity();
        }
      };
      appointmentForm.addEventListener('input', clearBookingError);
      appointmentForm.addEventListener('change', clearBookingError);
      appointmentForm.addEventListener('focusin', enhanceBookingLayout);
      appointmentForm.addEventListener('click', validateAppointmentTime, true);
      appointmentForm.addEventListener('submit', validateAppointmentTime, true);
      const observer = new MutationObserver(function () {
        if (!appointmentForm.hidden) {
          enforceFullAppointmentValue();
          enhanceAppointmentFields();
          updateAppointmentSummary();
        }
      });

      observer.observe(appointmentForm, {
        childList: true,
        subtree: true
      });

      appointmentForm.addEventListener('reset', function () {
        window.setTimeout(function () {
          if (!appointmentForm.hidden) enforceFullAppointmentValue();
        }, 0);
      }, true);

      appointmentForm.addEventListener('focusin', function (event) {
        if (event.target === findModelInput()) enforceFullAppointmentValue();
      });

      appointmentForm.addEventListener(
        'input',
        function (event) {
          const modelInput = findModelInput();

          if (
            modelInput &&
            event.target === modelInput &&
            modelInput.value !== lastExpectedValue
          ) {
            window.setTimeout(enforceFullAppointmentValue, 0);
          }
        },
        true
      );

      appointmentForm.addEventListener(
        'submit',
        function () {
          enforceFullAppointmentValue();
        },
        true
      );

      appointmentForm.addEventListener(
        'click',
        function (event) {
          const submitButton = event.target.closest(
            'button[type="submit"], button.submit, .action.submit'
          );

          if (submitButton) {
            enforceFullAppointmentValue();
          }
        },
        true
      );
    }

    if (window.PCBForms) {
      window.PCBForms.watchApp(appointmentForm, section.dataset.thankYouUrl);
      window.PCBForms.watchApp(quoteForm, section.dataset.thankYouUrl);
    }

    updateServicesAvailability();

    if (servicesGrid) {
      setServicesOpen(false);
    }

    updateSummary();

    /* Sécurité supplémentaire : force l'affichage "Sur devis" pour toute réparation à 0 €. */
    function enforceQuoteDisplay() {
      const buttons = Array.from(section.querySelectorAll('[data-repair-option]'));
      const paidPrices = [];

      buttons.forEach((button) => {
        const price = Number(button.dataset.salePrice || 0);
        const isQuote = price <= 0;

        if (!isQuote) {
          paidPrices.push(price);
          return;
        }

        button.dataset.quote = 'true';

        const title = button.querySelector('.repair-option__title-row strong');
        if (title && title.textContent.trim().toLowerCase() === 'default title') {
          title.textContent = 'Réparation';
          button.dataset.service = 'Réparation';
        }

        const discount = button.querySelector('.repair-option__discount');
        if (discount) discount.remove();

        const subtitle = button.querySelector('.repair-option__name small');
        if (subtitle) subtitle.textContent = 'Tarif sur devis, confirmé en boutique';

        const prices = button.querySelector('.repair-option__prices');
        if (prices) prices.innerHTML = '<strong>Sur devis</strong>';
      });

      const starting = section.querySelector('.repair-product__starting-price');
      if (starting) {
        const label = starting.querySelector('span');
        const value = starting.querySelector('strong');

        if (paidPrices.length) {
          const minPrice = Math.min(...paidPrices);
          if (label) label.textContent = 'À partir de';
          if (value) value.textContent = moneyFormatter.format(minPrice / 100);
        } else {
          if (label) label.textContent = 'Tarif';
          if (value) value.textContent = 'Sur devis';
        }
      }

      if (!selectedOptions().length) {
        if (totalSale) totalSale.textContent = '—';
        if (mobileTotal) mobileTotal.textContent = '—';
      } else {
        updateSummary();
      }
    }

    enforceQuoteDisplay();
    window.setTimeout(enforceQuoteDisplay, 100);
    window.setTimeout(enforceQuoteDisplay, 500);

    updateProgressSteps();
    hideExternalFloatingWidgets();

    window.setTimeout(hideExternalFloatingWidgets, 500);
    window.setTimeout(hideExternalFloatingWidgets, 1500);
    window.setTimeout(hideExternalFloatingWidgets, 3500);

    const floatingWidgetObserver = new MutationObserver(function () {
      scheduleFloatingWidgetScan();
    });

    floatingWidgetObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
